import bugsnag from 'bugsnag-js';
import createPlugin from 'bugsnag-react';
import React from 'react';
import config from '../config';

export const LEVEL_INFO = 'info';
export const LEVEL_WARNING = 'warning';
export const LEVEL_ERROR = 'error';

const snag = bugsnag({
  apiKey: config.bugSnag.API_KEY,
  notifyReleaseStages: ['production'],
});

snag.app.version = config.app.version;
snag.app.releaseStage = config.bugSnag.RELEASE;
snag.app.appType = 'admin';
const ErrorBoundary = snag.use(createPlugin(React));

export function setLoggerUser(email) {
  snag.user = { email };
}

export async function notify(message, level, handler) {
  snag.metaData = { handler };
  snag.notify(new Error(message), {
    severity: level,
    // beforeSend: function (report) {
    //   if (report.user.id === '1') report.ignore()
    // },
    // context: 'component-space-246',
    // device: { orientation: 'portrait' },
    // request: { id: 12345 },
  });
}

export default ErrorBoundary;



// WEBPACK FOOTER //
// ./src/utils/logger.js